import './assets/main.css'
import './assets/icons/iconfont.js'

import { createApp,ref } from 'vue'
import pinia from '@/stores/index.js'

import App from './App.vue'
import router from './router'

console.log('process.env.NODE_ENV', import.meta.env.VITE_API_BASE_URL,)

const app = createApp(App)

export const isRouterReady = ref(false)

app.use(pinia)
app.use(router)

app.mount('#app')
